// Module
var code = "<script>let $panelServiceInfo</script> <div ng-include=\"$panelServiceInfo.getTemplate()\"></div> ";
// Exports
module.exports = code;